import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import LocationHero from "./components/Hero";
import TrustBar from "../home/components/TrustBar";
import LocationDetail from "./components/LocationDetail";
import LocationAIAnswerBlock from "./components/AIAnswerBlock";
import Process from "../home/components/Process";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreas from "../home/components/ServiceAreas";
import Testimonials from "../home/components/Testimonials";
import LocationFAQ from "./components/FAQ";
import FinalCTA from "../home/components/FinalCTA";

export default function Location() {
  return (
    <div className="bg-charcoal font-sans">
      <Navbar />
      <main>
        <LocationHero />
        <TrustBar />
        <LocationDetail />
        <LocationAIAnswerBlock />
        <Process />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <LocationFAQ />
        <FinalCTA />
      </main>
      <Footer />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 lg:hidden z-40 bg-charcoal-100/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex gap-3">
        <a
          href="tel:4154539180"
          className="flex-1 flex items-center justify-center gap-2 border border-gold text-gold font-sans text-sm font-semibold py-3 rounded whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-phone-line text-sm"></i>
          </div>
          Call Now
        </a>
        <button
          onClick={() => {
            const el = document.querySelector("#contact");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
          className="flex-1 bg-gold text-charcoal font-sans text-sm font-semibold py-3 rounded whitespace-nowrap cursor-pointer"
        >
          Reserve Storage
        </button>
      </div>
    </div>
  );
}
